'use client';

import React from 'react';

import { AccordionButton, AccordionItem, AccordionPanel, Box } from '@chakra-ui/react';
import { HiMinus, HiPlus } from 'react-icons/hi';

import { CustomText } from '@components/Custom-text';

type FaqsProps = {
    question: string;
    answer: string;
    index: number;
    count: number;
};

const Faqs = ({ answer, question, index, count }: FaqsProps) => (
    <AccordionItem
        borderTop={index === 0 ? 'none' : ''}
        borderBottom={index === count - 1 ? 'none' : ''}
    >
        {({ isExpanded }) => (
            <>
                <Box as="h2">
                    <AccordionButton p={0} py={3}>
                        <Box flex="1" textAlign="left">
                            <CustomText size="lg" color="titleText" weight={500}>
                                {question}
                            </CustomText>
                        </Box>
                        {isExpanded ? (
                            <HiMinus fontSize="15px" color="#4c50ea" />
                        ) : (
                            <HiPlus fontSize="15px" color="#4c50ea" />
                        )}
                    </AccordionButton>
                </Box>
                <AccordionPanel p={0} pb={3}>
                    <CustomText color="faqsSubText" size="md" textAlign="justify">
                        <span
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: answer }}
                        />
                    </CustomText>
                </AccordionPanel>
            </>
        )}
    </AccordionItem>
);

export default Faqs;
